import SeoLandingPage from "../components/SeoLandingPage";

const page = {
  path: "/autocert",
  breadcrumbName: "Aptofy AutoCert™",
  serviceType: "Automated Certification Software",
  eyebrow: "Aptofy AutoCert™",
  title: "Aptofy AutoCert™ | Automated Certification & Proctored Assessments",
  description:
    "Aptofy AutoCert™ automates certification assessments with AI-proctored exams, scoring, and verifiable certificate generation for institutes and enterprise L&D teams.",
  keywords:
    "Aptofy AutoCert, automated certification software, online certificate assessment, AI proctored certification, certificate generation platform, training certification software, exam and certification platform, digital certificates, proctored exam software",
  h1: "Aptofy AutoCert™ — Automated Certification and Skill Assessments",
  intro:
    "Issue trusted certificates without building exam infrastructure. AutoCert™ delivers secure, proctored assessments, automated evaluation, and verifiable certificates for training institutes, academies, and enterprise learning programs.",
  sections: [
    {
      heading: "What Is Automated Certification Software?",
      paragraphs: [
        "Automated certification software runs exams, scores learners, and generates certificates with minimal manual invigilation. The strongest platforms add proctoring, integrity checks, and verification so certificates remain credible.",
        "Aptofy AutoCert™ is built as Certificate Assessment and Trainings as a Service — your brand owns the content and outcomes; Aptofy handles secure delivery, evaluation, and certificate workflows.",
      ],
    },
    {
      heading: "How AutoCert™ Works",
      paragraphs: [
        "Create or upload assessments, invite learners, and run AI-proctored exams. AutoCert™ evaluates responses, produces reports, and generates certificates your organization can issue and verify — including QR-backed verification to reduce tampering.",
      ],
      bullets: [
        "Secure online exam delivery",
        "AI-powered proctoring and integrity checks",
        "Automated scoring across question types",
        "Certificate generation at scale",
        "Verification to protect credential trust",
        "Training and assessment as a managed service",
      ],
    },
    {
      heading: "Key Features",
      bullets: [
        "Proctored certification exams",
        "MCQ, coding, and descriptive evaluation",
        "Learner invites and attempt tracking",
        "Industry-aligned certification workflows",
        "Reports for institutes and hiring partners",
        "Works alongside TalentOS™ and IntelliHire™",
      ],
    },
    {
      heading: "Benefits for Institutes and L&D Teams",
      paragraphs: [
        "AutoCert™ lets training organizations scale assessments without scaling invigilators. Learners get a fair, consistent exam experience. Employers and partners get credentials they can trust.",
      ],
      bullets: [
        "No need to build exam infrastructure",
        "Higher assessment integrity",
        "Faster certificate turnaround",
        "Brand-ready certification programs",
      ],
    },
    {
      heading: "Who AutoCert™ Is For",
      bullets: [
        "Training institutes and academies",
        "Corporate L&D and upskilling programs",
        "Certification bodies and COEs",
        "Employers validating internal skill programs",
        "Partners issuing role-ready credentials",
      ],
    },
  ],
  faqs: [
    {
      question: "Are AutoCert™ exams proctored?",
      answer:
        "Yes. AutoCert™ uses AI-supported proctoring to improve exam integrity and reduce cheating during certification assessments.",
    },
    {
      question: "Can we issue certificates under our own brand?",
      answer:
        "Yes. AutoCert™ is designed so your organization can focus on content, learners, and outcomes while Aptofy handles delivery, evaluation, and certificate generation.",
    },
    {
      question: "How are certificates verified?",
      answer:
        "Aptofy supports verifiable certificate workflows, including QR-backed verification, to help prevent tampering and fake credentials.",
    },
    {
      question: "Is AutoCert™ only for training institutes?",
      answer:
        "No. Enterprises also use AutoCert™ for internal certifications, role readiness, and skill validation before mobility or client deployment.",
    },
  ],
  ctaHeading: "Automate certification with AutoCert™",
  ctaText:
    "Request a demo or start a free trial to see how Aptofy AutoCert™ can run proctored exams and issue trusted certificates at scale.",
};

export default function AutoCertPage() {
  return <SeoLandingPage page={page} />;
}
